import { useEffect, useState } from 'react';

/**
 * Observes the DOM for an element matching a CSS selector (e.g. spotlight mount target).
 */
export const useHtmlSelector = ({ selector }: { selector?: string }): HTMLElement | undefined => {
	const [el, setEl] = useState<HTMLElement | undefined>();

	useEffect(() => {
		if (typeof globalThis.document === 'undefined' || !selector) {
			setEl(undefined);
			return;
		}

		const check = () => {
			const element = globalThis.document.querySelector(selector) as HTMLElement | null;
			setEl(element ?? undefined);
		};

		check();

		const observer = new MutationObserver(check);

		observer.observe(globalThis.document.body, {
			childList: true,
			subtree: true,
		});

		return () => {
			observer.disconnect();
		};
	}, [selector]);

	return el;
};
